import React from "react";
import "../../styles/LegalPages.css";

export default function TermsConditions() {
  return (
    <main className="legal-page">
      <section className="legal-hero">
        <p className="legal-label">Victoria Sports Club</p>
        <h1>Terms & Conditions</h1>
        <p>
          By using this website and registering for our services or events, you agree to these terms.
        </p>
      </section>

      <section className="legal-card">
        <h2>Participation</h2>
        <p>
          Participation in Victoria Sports Club events and activities is voluntary. Participants are responsible
          for ensuring they are physically fit and medically capable of joining.
        </p>

        <h2>Registration</h2>
        <p>
          Users must provide accurate and complete registration information. Victoria Sports Club reserves the
          right to refuse, suspend, or cancel registrations with false or misleading details.
        </p>

        <h2>Payments</h2>
        <p>
          Payments made through the website are subject to applicable registration fees, payment processing
          policies, and event guidelines.
        </p>

        <h2>Event Changes</h2>
        <p>
          Victoria Sports Club may modify schedules, event details, routes, or policies when necessary for safety,
          operations, or unforeseen circumstances.
        </p>

        <h2>Media Release</h2>
        <p>
          Participants grant permission for photos, videos, and media content taken during events to be used for
          promotional and marketing purposes.
        </p>

        <h2>Liability</h2>
        <p>
          Victoria Sports Club shall not be held liable for injuries, losses, damages, delays, or unforeseen
          incidents related to participation in events or website usage.
        </p>
      </section>
    </main>
  );
}